import {BrowserRouter as Router,Routes,Route,useLocation} from 'react-router-dom';
import {useEffect} from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieManagerComponent from './components/CookieManager';
import {LanguageProvider} from './context/LanguageContext';
import Home from './pages/Home';
import LandingPage from './pages/LandingPage';
import Courses from './pages/Courses';
import FreeResources from './pages/FreeResources';
import Categories from './pages/Categories';
import About from './pages/About';
import Contact from './pages/Contact';
import DemoPage from './pages/DemoPage';
import Schools from './pages/Schools';
import TreatmentCenters from './pages/TreatmentCenters';

// Componente per gestire lo scroll all'inizio quando si cambia pagina 
function ScrollToTop() {
  const {pathname,hash}=useLocation();
  useEffect(()=> {
    // Solo se non c'è un hash nell'URL (non è un link interno) 
    if (!hash) {
      window.scrollTo(0,0);
    }
  },[pathname,hash]);
  return null;
} 

function App() {
  return ( 
    <LanguageProvider> 
      <Router> 
        <ScrollToTop /> 
        <div className="flex flex-col min-h-screen"> 
          <Navbar /> 
          <main className="flex-grow"> 
            <Routes> 
              <Route path="/" element={<LandingPage />} /> 
              <Route path="/home" element={<Home />} /> 
              <Route path="/courses" element={<Courses />} /> 
              <Route path="/free-resources" element={<FreeResources />} /> 
              <Route path="/categories" element={<Categories />} /> 
              <Route path="/about" element={<About />} /> 
              <Route path="/contact" element={<Contact />} /> 
              <Route path="/demo" element={<DemoPage />} /> 
              <Route path="/schools" element={<Schools />} /> 
              <Route path="/treatment-centers" element={<TreatmentCenters />} /> 
            </Routes> 
          </main> 
          <Footer /> 
          <CookieManagerComponent /> 
        </div> 
      </Router> 
    </LanguageProvider> 
  );
}

export default App;